import { createConsumer } from "@rails/actioncable"

const CABLE_URL = "/cable" as const

const consumerCache = new Map<string, ReturnType<typeof createConsumer>>()

/**
 * Returns a cached ActionCable consumer for the given space group.
 * Reuses the same WebSocket connection across all channels within a space group.
 */
export function getConsumer(spaceGroupId: string) {
  let consumer = consumerCache.get(spaceGroupId)
  if (!consumer) {
    // Security: space_group_id is read from server-side session, not passed in URL
    // This prevents tenant enumeration attacks
    consumer = createConsumer(CABLE_URL)
    consumerCache.set(spaceGroupId, consumer)
  }
  return consumer
}

/**
 * Removes a cached consumer for the given space group, forcing a new connection on next getConsumer call.
 */
export function disconnectConsumer(spaceGroupId: string) {
  consumerCache.delete(spaceGroupId)
}
